<template>
  <div>
    <div class="float-win">
      <div class="header">免费课程</div>
      <div class="content">
        <div class="list">
          <div
            class="list-item"
            @click="linkHandle(item)"
            v-for="(item, index) in linkList.filter((i) => i.string1 != '2')"
            :key="index"
          >
            {{ item.string3 }}
          </div>
        </div>
      </div>
      <div class="footer" @click="showMoreCourse">更多课程</div>
    </div>
    <el-dialog
      custom-class="link-code-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div class="title">扫码看更多免费中医课程</div>
      <div class="qr-code">
        <img :src="qr_img" alt="" style="width: 180px; height: 180px" />
      </div>
      <div class="tips">打开微信扫一扫</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: [],
      dialogVisible: false,
      qr_img: "",
    };
  },
  methods: {
    linkHandle(val) {
      window.open(val.string2);
    },
    showMoreCourse() {
      let item = this.linkList.find((i) => i.string1 == "2");
      if (item) {
        this.qr_img = item.string2;
        this.dialogVisible = true;
      }
    },
    getLinkList() {
      this.api("getWideUseDict", { targetUse: "CSG_LINK" }).then((res) => {
        this.linkList = res.result;
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  created() {
    this.getLinkList();
  },
};
</script>

<style lang="scss" >
.float-win {
  position: fixed;
  top: 50%;
  margin-left: -160px;
  transform: translateY(-50%);
  font-size: 14px;
  .header {
    width: 160px;
    height: 77px;
    background: url("./tc/tc_01.png");
    overflow: hidden;
    text-align: center;
    box-sizing: border-box;
    padding: 35px 0 0;
    color: #771718;
    font-weight: bold;
  }
  .content {
    width: 160px;
    background: url("./tc/tc_02.jpg") top center;
    padding: 10px 25px 10px 40px;
    box-sizing: border-box;
    font-weight: bold;
    .list {
      .list-item {
        line-height: 20px;
        padding: 5px 0;
        position: relative;
        cursor: pointer;
        &::after {
          content: " ";
          position: absolute;
          left: -10px;
          top: 50%;
          transform: translateY(-50%);
          border: 5px solid #f00;
          border-color: transparent transparent transparent #87a95c;
        }
      }
    }
  }
  .footer {
    width: 160px;
    height: 74px;
    overflow: hidden;
    background: url("./tc/tc_04.png");
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;
    padding: 20px 0 0;
    font-weight: bold;
    color: #0584f8;
  }
}
.link-code-dialog {
  .title {
    font-size: 22px;
    text-align: center;
    color: #333;
  }

  .qr-code {
    width: 180px;
    height: 180px;
    margin: 20px auto;
  }

  .tips {
    font-size: 16px;
    text-align: center;
  }
}
.dark {
  .float-win .content .list .list-item {
    color: #333;
  }
}
</style>
